import $ from 'jquery';

import ThemeUtils from '../utils/ThemeUtils';

export default class StaticSlideshow {
  constructor(instance) {
    this.$el = $(instance.el).find('.static-slideshow-wrapper');
    this.$document = $(document.body);
    this.$window = $(window);
    this.$slides = $('[data-slide]');

    this.$headerNavigation = $('[data-main-header]');
    this.$slideShow = this.$el.find('[data-slideshow-content]');
    this.windowWidth = null;

    this.slideText = '';
    this.autoplayInterval = null;
    this.slidesLocked = false;

    this.autoplaySpeed = instance.data.autoplay_speed;
    this.isFullWindow = instance.data.layout === 'full-window';
    this.isAutoplayEnabled = instance.data.enable_autoplay;

    this.$slideNavigation = $('.static-slideshow-navigation', this.$el);
    this.$slidePagination = $('.static-slideshow-pagination', this.$el);
    this.slidePaginationHeight = null;
    this.slideShowMinHeight = parseInt(this.$el.css('min-height'), 10);

    this.themeUtils = ThemeUtils;

    this.events = [
      this.$el.on('mouseenter.slideshow', () => this.pauseLoop()),
      this.$el.on('mouseleave.slideshow', () => this.startLoop()),
      $('.static-slideshow-previous', this.$el).on('click.slideshow', (event) => {
        event.preventDefault();
        this.previousSlide();
      }),
      $('.static-slideshow-next', this.$el).on('click.slideshow', (event) => {
        event.preventDefault();
        this.nextSlide();
      }),
      $('.static-slideshow-pagination > span', this.$el).on('click.slideshow', (event) => {
        event.preventDefault();
        this.specificSlide(event.currentTarget);
      }),
      $('.static-slideshow-navigation', this.$el).on('mouseout.slideshow', event => $(event.currentTarget).blur()),
    ];

    this.setupSlides();
    this.setupHeader();
  }

  setSlideshowClasses(event = null, $slide) {
    let slideText;
    if ($slide) {
      slideText = $slide.data('slide-text');
    } else {
      slideText = this.$slideShow.find('.active').data('slide-text');
    }

    if (slideText !== this.slideText) {
      this.$document
        .removeClass('slide-color-light slide-color-dark')
        .addClass(`slide-color-${slideText}`);
      this.slideText = slideText;
    }
  }

  getMaxSlideHeight(windowHeight, windowWidth) {
    let maxHeight = windowHeight - this.$headerNavigation.height();

    if (this.isFullWindow && (windowWidth > 720)) {
      maxHeight = windowHeight;
    }

    return maxHeight;
  }

  setupHeader() {
    this.$document
      .trigger('toggleStickyHeader', [this.$el])
      .trigger('toggleSlideShowHeader', [this.$el]);
  }

  setSlideHeight(settings) {
    let slideHeight;
    const { $slide, windowWidth, windowHeight } = settings;
    const $slideText = $slide.find('.slide-text');
    const $slideImage = $slide.find('.slide-image');

    const slidePadding = this.$slidePagination.length ? this.slidePaginationHeight * 2 : 60;
    const textHeight = $slideText.length ? $slideText.height() + slidePadding : 0;
    const imageHeight = $slideImage.height();
    const maxHeight = this.getMaxSlideHeight(windowHeight, windowWidth);

    if (this.isFullWindow) {
      const announcementBarEl = document.querySelector('.pxs-announcement-bar');
      slideHeight = windowWidth > 720 ? windowHeight : maxHeight;

      // If is full window, subtract announcement bar height
      if (announcementBarEl) {
        slideHeight -= announcementBarEl.getBoundingClientRect().height;
      }

      $slide.height(slideHeight);

    } else {
      // Minimum height is height of text, or image, which ever is larger
      // Slideshows have a CSS min height of 300px
      const minHeight = Math.max.apply(null, [this.slideShowMinHeight, textHeight, imageHeight]);

      // Use the smaller of the heights as the slide height
      slideHeight = Math.min.apply(null, [minHeight, maxHeight]);
    }

    $slide.attr('data-height', slideHeight);

    return slideHeight;
  }

  setupSlides() {
    this.$slides = this.$el.find('[data-slide]');
    this.slideCount = this.$slides.length;
    this.setSlideshowClasses(null, this.$slides.eq(0));

    const windowWidth = this.themeUtils.windowWidth();
    const windowHeight = this.themeUtils.windowHeight();

    this.slidePaginationHeight = this.$slidePagination.height();
    this.windowWidth = windowWidth;

    for (let i = 0; i < this.$slides.length; i++) {
      const slide = this.$slides[i];
      const $slide = $(slide);
      const slideID = $slide.attr('id');

      const slideHeight = this.setSlideHeight({
        $slide,
        windowWidth,
        windowHeight,
      });

      if (i === 0) {
        $slide.addClass('active');

        this.$el.height(slideHeight);
        this.setNavHeight(slideHeight);
        this.$el.attr('id', `viewing-${slideID}`);
      }

      if ((i + 1) === this.slideCount) {
        this.$el.addClass('slides-ready');
      }
    }

    this.$window.on('resize.slideshow', () => {
      if (this.themeUtils.windowWidth() === this.windowWidth) { return; }
      this.resetSlideHeights();
    });

    this.startLoop();
  }

  resetSlideHeights() {
    const windowWidth = this.themeUtils.windowWidth();
    const windowHeight = this.themeUtils.windowHeight();

    this.windowWidth = windowWidth;

    // Iterate over each slide, so that on slide change, slides have new heights

    this.$slides.each((index, slide) => {
      const $slide = $(slide);
      const slideHeight = this.setSlideHeight({
        $slide,
        windowWidth,
        windowHeight,
      });

      if ($slide.hasClass('active')) {
        this.$el.height(slideHeight);
        this.setNavHeight(slideHeight);
      }
    });
  }

  resetPaginationPosition(height) {
    if (this.themeUtils.windowWidth() <= 720) {
      this.$slidePagination.css({
        bottom: 'auto',
        top: height - 50,
      });
    }
    this.$slidePagination.css({
      bottom: 0,
      top: 'auto',
    });
  }

  previousSlide() {
    if (this.sliding) { return; }
    this.showNewSlide('prev');
  }

  nextSlide() {
    if (this.sliding) { return; }
    this.showNewSlide('next');
  }

  specificSlide(target) {
    if (!$(target).hasClass('active')) {
      const nextSlideID = $(target).data('slide-id');
      this.showNewSlide('next', nextSlideID);
    }
  }

  updateSlidePagination(index) {
    this.$slidePagination.find('.active').removeClass('active');
    this.$slidePagination.find('> span').eq(index).addClass('active');
  }

  lockSlide(slideID) {
    this.slidesLocked = true;
    this.pauseLoop();
    this.showNewSlide('next', slideID);
  }

  unlockSlide() {
    this.slidesLocked = false;
    this.startLoop();
  }

  showNewSlide(type, specificSlide) {
    this.sliding = true;

    if (this.$slides.length === 1) {
      this.sliding = false;
      return;
    }

    const direction = type === 'next' ? 'left' : 'right';
    const fallback = type === 'next' ? 'first' : 'last';

    const $activeSlide = this.$slideShow.find('.active');
    let $nextSlide = specificSlide ? $(`#${specificSlide}`) : $activeSlide[type]();

    $nextSlide = $nextSlide.length ? $nextSlide : this.$slides[fallback]();

    if ($activeSlide.attr('id') === $nextSlide.attr('id')) { return; }

    $nextSlide.addClass(type);
    $nextSlide[0].offsetWidth; // force reflow
    $activeSlide.addClass(direction);
    $nextSlide.addClass(direction);

    $nextSlide.one('transitionend', () => {
      $nextSlide.removeClass([type, direction].join(' ')).addClass('active');
      $activeSlide.removeClass(['active', direction].join(' '));
      this.sliding = false;
    });

    const imageHeight = parseInt($nextSlide.attr('data-height'), 10);

    this.updateSlidePagination($nextSlide.index());
    this.setNavHeight(imageHeight);
    this.setSlideshowClasses(null, $nextSlide);

    const slideID = $nextSlide.attr('id');
    this.$el.attr('id', `viewing-${slideID}`);
    this.$el.height(imageHeight);
  }

  startLoop() {
    if (!this.isAutoplayEnabled || this.slidesLocked) {
      return;
    }

    this.autoplayInterval = setInterval(() => this.nextSlide(), this.autoplaySpeed);
  }

  pauseLoop() {
    if (this.autoplayInterval == null) { return; }
    clearInterval(this.autoplayInterval);
  }

  setNavHeight(imageHeight) {
    this.$slideNavigation.css({ lineHeight: `${imageHeight}px` });
  }

  onSectionBlockSelect(block) {
    this.lockSlide(block.el.id);
  }

  onSectionBlockDeselect() {
    this.unlockSlide();
  }

  onSectionUnload() {
    this.events.forEach($el => $el.off('.slideshow'));
  }
}
